import { render, staticRenderFns } from "./NewsSearch.vue?vue&type=template&id=aea4715e"
import script from "./NewsSearch.vue?vue&type=script&lang=js"
export * from "./NewsSearch.vue?vue&type=script&lang=js"
import style0 from "./NewsSearch.vue?vue&type=style&index=0&id=aea4715e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports